export default api => ({
  register: data => api.post('auth/register', data),
  checkPhone: data => api.post('auth/register/check_phone', data),
  checkEmail: data => api.post('auth/register/check_email', data),
  setPassword: data => api.post('auth/register/set_password', data),

  askPassword: data => api.post('auth/password/ask', data),
  checkCode: data => api.post('auth/password/check_code', data),
  checkResetToken: (uidb64, token) => api.get(`auth/password/reset/${uidb64}/${token}`),
  resetPassword: data => api.post('auth/password/reset', data),
  changePassword: data => api.post('auth/change_password/', data),
  changePasswordConfirm: data => api.post('auth/change_password/confirm', data),
  sendCode: data => api.post('auth/register/send_code', data),
  mailManager: data => api.post('auth/mail_manager', data),
  userInfo: () => api.get('auth/userinfo'),
  updateUserInfo: data => api.post('auth/userinfo/',data),
  updateRegisterDataSource: data => api.post('auth/userinfo/',data),
  getPhoneVerifyCode: () => api.get('auth/verify_phone'),
  confirmPhoneVerifyCode: (data) => api.post('auth/verify_phone', data)
})
